import { ChangeDetectorRef, Directive, effect, input, InputSignal, output, OutputEmitterRef, inject } from '@angular/core';
import { DataAnalyticsTaggingEvent } from './data-analytics-tagging.domain';
import { DataAnalyticsTaggingService } from './data-analytics-tagging.service';

@Directive({
  selector: '[tdWbDataAnalyticsTagging]'
})
export class DataAnalyticsTaggingDirective {
  private readonly dataAnalyticsTaggingService = inject(DataAnalyticsTaggingService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  analyticsCompleted: OutputEmitterRef<DataAnalyticsTaggingEvent> = output<DataAnalyticsTaggingEvent>();

  dataAnalyticsTaggingEventSignal: InputSignal<DataAnalyticsTaggingEvent> =
    input<DataAnalyticsTaggingEvent>({}, { alias: 'eventSignal' });

  constructor() {
    // effect: emits tagging events and marks host for re-check — required because
    // the signal input produces side effects to an external analytics service.
    effect(() => {
      const event = this.dataAnalyticsTaggingEventSignal();
      if (event && (event.page || event.link || event.search)) {
        if (event.link && event.link.name?.length === 0) {
          return;
        }
        this.dataAnalyticsTaggingService.emitTaggingEvent(event);
        this.analyticsCompleted.emit(event);
      }
      this.changeDetectorRef.markForCheck();
    });
  }
}
